import { StrictMode, Suspense, lazy } from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import './styles/global.scss';

/**
 * Hai ứng dụng, một bản dựng — và chúng KHÔNG được dùng chung gói JavaScript.
 *
 * `/bang-diem` là trang công khai cho tài xế, mở bằng link trong Zalo trên điện thoại và
 * mạng di động. CMS thì kéo theo antd, lucide, react-router — gói chung lại là 1,55 MB
 * (484 KB nén). Bắt một người chỉ muốn xem mình đang bao nhiêu điểm tải chừng ấy là trang
 * trắng vài giây rồi họ đóng đi.
 *
 * Nên chia ngay ở đây, TRƯỚC khi `App` được import: đọc đường dẫn rồi `lazy()` đúng một
 * nhánh. `import()` động khiến Rollup cắt hai chunk riêng, và nhánh không dùng thì không tải.
 *
 * Chia ở `main.tsx` chứ không phải bằng một `<Route>` trong `App`: chỉ cần `App.tsx` nằm
 * trong đồ thị phụ thuộc là antd đã vào gói, dù trang công khai chẳng vẽ một thành phần antd
 * nào. Phải cắt trước `App`, không có cách nào khác.
 */
const CmsApp = lazy(() => import('./App'));
const PublicBoardPage = lazy(() => import('./public-board/PublicBoardPage'));

/*
 * Đọc `location` một lần lúc khởi động.
 *
 * Trang công khai không có liên kết nào dẫn sang CMS và ngược lại, nên không cần theo dõi
 * đường dẫn đổi — người ta đi qua lại bằng cách gõ địa chỉ, tức là tải lại trang.
 */
const duong = window.location.pathname;
// `/bang-diem` is the old URL, kept because scoreboard links were already shared in chats.
const laBangDiem = duong.startsWith('/scoreboard') || duong.startsWith('/bang-diem');

const root = document.getElementById('root');
if (!root) throw new Error('Không tìm thấy #root trong index.html');

createRoot(root).render(
  <StrictMode>
    {/*
      `fallback` để trống, cố ý: hai chunk này tải trong vài chục mili-giây từ cùng máy chủ,
      và một chữ "Đang tải…" nhấp nháy rồi biến mất còn khó chịu hơn một khoảnh khắc trắng.
    */}
    <Suspense fallback={null}>
      {laBangDiem ? (
        <PublicBoardPage />
      ) : (
        /*
          `BrowserRouter` chứ không `HashRouter`: địa chỉ ra `/diem` thay vì `/#/diem`, đọc
          được và dán được cho người khác. Đổi lại, máy chủ phải trả `index.html` cho những
          đường dẫn không có tệp thật — Vite lo phần đó lúc phát triển, còn lúc chạy thật thì
          `serveCms()` trong xemy-point-backend/src/index.ts lo.

          Chỉ bọc nhánh CMS: trang công khai là một trang duy nhất, không điều hướng đi đâu.
        */
        <BrowserRouter>
          <CmsApp />
        </BrowserRouter>
      )}
    </Suspense>
  </StrictMode>,
);
